import { useDispatch } from 'react-redux';
import { useCallback } from 'react';
import { plotterActions } from './plotterSlice';
import { fromLonLat } from 'ol/proj';
import { Coordinate } from 'ol/coordinate';

export type LocationLike =
  | [number | string, number | string]
  | { lat: number | string; lng: number | string };

export const usePanMap = () => {
  const dispatch = useDispatch();

  const panMap = <T extends LocationLike>(location: T, zoom: number = 8) => {
    let center: Coordinate = [0, 0];
    if (!Array.isArray(location) && location?.lat && location?.lng) {
      center = fromLonLat([Number(location.lng), Number(location.lat)]);
    } else if (Array.isArray(location) && location.length >= 2) {
      center = fromLonLat([Number(location[1]), Number(location[0])]);
    }
    dispatch(
      plotterActions.setMapView({
        center,
        zoom,
      }),
    );
  };
  return panMap;
};

export const useFitMap = () => {
  const dispatch = useDispatch();

  const fitMap = useCallback(
    (locations: LocationLike[]) => {
      const arrayLocations = locations
        .map((location) => {
          if (!Array.isArray(location) && location?.lat && location?.lng) {
            return fromLonLat([Number(location.lng), Number(location.lat)]);
          } else if (Array.isArray(location) && location.length >= 2) {
            return fromLonLat([Number(location[1]), Number(location[0])]);
          } else {
            return null;
          }
        })
        .filter((loc) => loc !== null) as Coordinate[];
      if (arrayLocations) {
        dispatch(plotterActions.fitMapView(arrayLocations));
      } else {
        console.warn('Invalid location provided to fitMap:', locations);
      }
    },
    [dispatch],
  );
  return fitMap;
};
